 const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("in");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.1 },
      );
    document.querySelectorAll(".card, .step, .archive-content, .story blockquote").forEach((el) => {
        el.classList.add("reveal");
        io.observe(el);
    });